import { SyntheticEvent } from "react";
import { isEnter, isSpace } from "./keyboardEvents";

export const preventDefault =
  <E extends Element, T extends SyntheticEvent<E>>(eventHandler?: (event: T) => void) =>
  (event: T) => {
    event.preventDefault();
    eventHandler?.(event);
  };

export const stopPropagation =
  <E extends Element, T extends SyntheticEvent<E>>(eventHandler?: (event: T) => void) =>
  (event: T) => {
    event.stopPropagation();
    eventHandler?.(event);
  };

export const buttonRoleProps = <E extends Element, T extends SyntheticEvent<E>>(
  eventHandler: ((event: T) => void) | undefined,
) =>
  !eventHandler
    ? {}
    : {
        role: "button",
        tabIndex: 0,
        onClick: (event: T) => {
          event.preventDefault();
          event.stopPropagation();
          eventHandler(event);
        },
        onKeyDown: (event: T) => {
          if (isEnter(event) || isSpace(event)) {
            event.preventDefault();
            event.stopPropagation();
            eventHandler(event);
          }
        },
      };
